import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { ProductContextFacade } from 'ish-core/facades/product-context.facade';

/**
 * The Product Label Component renders a label for a product with label information, i.a. new, sale or top seller.
 *
 * @example
 * <ish-product-label></ish-product-label>
 */
@Component({
  selector: 'ish-product-label',
  templateUrl: './product-label.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, TranslateModule],
})
export class ProductLabelComponent implements OnInit {
  private context = inject(ProductContextFacade);

  productLabel$: Observable<string>;

  ngOnInit() {
    this.productLabel$ = this.context.select('label');
  }
}
